import React from "react";

const Product = ({ setSubMenuindex }) => {
  const handler = () => {
    setSubMenuindex([]);
  };

  return (
    <div onMouseOver={handler} style={{ margin: "20rem" }}>
      <h2>Products</h2>

      <p> Left blank because this is a demo</p>
    </div>
  );
};

export default Product;
